module.exports = __webpack_public_path__ + "media/video-poster/poster-af67cc34.jpg";